import createInboxStore from '@app/application/communication/screens/inbox/store/inbox'
import { createApp } from '@app/adapters/create-app'
import InboxFilters from '@app/application/communication/screens/inbox/components/inbox-filters.vue'
import CompanyInbox from '@app/application/communication/screens/inbox/components/company-inbox.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='workflow-inbox']").each(function () {
    const data = $(this).data()
    const endpointParams = {
      companyId: Silverfin.currentCompanyId,
      ledgerId: Silverfin.currentLedgerId(),
      firmId: Silverfin.currentFirmId,
      contextType: data.contextType,
      contextId: data.contextId,
    }

    const store = createInboxStore(endpointParams)
    const workflowInboxApp = createApp(CompanyInbox, {
      initialCategory: $(this).data('category'),
      initialItem: $(this).data('item'),
    })
    workflowInboxApp.use(store)
    workflowInboxApp.mount(this)

    $dom.find("[data-behaviour='inbox-filters']").each(function () {
      const filtersApp = createApp(InboxFilters, {
        initialSearch: $(this).data('search') || '',
        initialNoteType: $(this).data('noteType') || null,
        initialAuthors:
          $(this)
            .data('authors')
            ?.toString()
            ?.split(',')
            ?.map((value) =>
              value === 'external' ? value : Number.parseInt(value)
            ) || [],
        initialTags:
          $(this).data('tags')?.toString()?.split(',')?.map(Number.parseInt) ||
          [],
      })
      filtersApp.use(store)
      filtersApp.mount(this)
    })
  })
})
